import $ from "jquery";
import Backbone from "backbone";
import BaseApp from "../BaseApp";
import NotificationModel from "./model/NotificationModel";
import Notification from "./Notification";
import NotificationChannel from "./NotificationChannel";
import langDictionary from "../../classes/lang/init";
import "../../plugins/realSize";


let notShowMessage = true;

let Stack = function() {
    let stack = [];

    stack.remove = function(elem) {
        let index = this.indexOf(elem);
        if ( index != -1 ) {
            this.splice(index, 1);
        }
    };

    stack.getTotalHeight = function() {
        let totalHeight = 0;
        this.forEach((notification) => {
            if ( notification.isShowed ) {
                totalHeight += notification.height;
            }
        });
        return totalHeight;
    };

    stack.clone = function() {
        let clone = new Stack();
        this.forEach((notification) => {
            clone.push(notification);
        });
        return clone;
    };

    return stack;
};

export default class NotificationApp extends BaseApp {
    channel() {return NotificationChannel;}
    channelEvents() {
        return {
            add: "onChannelAdd",
            closeNotyBy: "onChannelCloseNotyBy"
        };
    }

    onReady() {
        this.toShow = new Stack();
        this.visible = new Stack();
        setInterval(this.onFrame.bind(this), 100);
    }

    showNotificationsTable() {
        system.apps.run("noty_table");
    }

    onFrame() {
        // удаляем старые
        let time = Date.now();
        this.visible.forEach((notification) => {
            let timeout = notification.model.get("timeout") || 60 * 1000;
            if (
                !notification.$element.hasClass("hover")
                    && notification.time + timeout < time
            ) {
                notification.hide();
            }
        });

        // показываем новые, если влезают в экран
        this.toShow.some((notification) => {
            let box = document.querySelector(".Notification-box");
            let openedNoty = $(".Notification.opened");
            if ( !box || openedNoty.length < 3 ) {

                if ( !notShowMessage ) {
                    this.visible.push(notification);
                    this.toShow.remove(notification);
                } else {
                    this.visible.push(notification);
                    this.toShow.remove(notification);
                    notification.$element.prependTo(this.getBox());
                    notification.height = notification.$element.realSize().height;
                    notification.show();

                    this.playSound();
                }
            } else {
                return true;
            }
        });
    }

    getBox() {
        if ( this.$box ) {
            return this.$box;
        }

        let $box = $("<div class='Notification-box'></div>").appendTo(document.body);
        this.$box = $box;

        return $box;
    }

    playSound() {
        let src = "sounds/notify";
        let $sound = $("<audio autoplay=\"autoplay\" style=\"display:none;\">"
                + "<source src=\"" + src + ".mp3\" />"
                + "<source src=\"" + src + ".wav\" />"
                + "<embed src=\"" + src + ".mp3\" hidden=\"true\" autostart=\"true\" loop=\"false\" class=\"playSound\" />"
                + "</audio>").appendTo(document.body);

        setTimeout(() => {
            $sound.remove();
        }, 3000);
    }

    add(modelAdd) {

        if ( !(modelAdd instanceof Backbone.Model) ) {
            modelAdd = new NotificationModel(modelAdd);
        }

        let notification = new Notification({
            model: modelAdd,
            cssName: modelAdd.get("cssName"),
            click: modelAdd.get("click"),
            close: modelAdd.get("close")
        });

        this.listenTo(notification, "hide close", () => {
            this.toShow.remove(notification);
            this.visible.remove(notification);
        });

        this.toShow.push(notification);
        this.addCloseBox();

        return notification;
    }

    addCloseBox() {
        let openedNoty = $(".Notification.opened");
        let closeBox = document.querySelector(".Notification--closeAll");

        if ( openedNoty.length > 2 && !closeBox ) {
            let closeAllText = langDictionary.get("close_all_noty");
            $(".Notification-box").append(`<div class='Notification--closeAll'>${closeAllText}</div>`);
            this.$closeBox = $(".Notification--closeAll");
            this.listenTo(this.$closeBox, "click", () => {
                this.onChannelCloseNotyBy(() => true);

                notShowMessage = false;

                setTimeout(() => {
                    notShowMessage = true;
                }, 3000);

                let closeElem = this.$closeBox[0];
                if ( closeElem && closeElem.parentNode ) {
                    closeElem.outerHTML = "";
                }
            });
        }
    }

    onChannelCloseNotyBy(filter) {
        this.closeNotyBy(filter);
    }

    closeNotyBy(filter) {
        this.toShow.forEach((noty) => {
            if ( filter(noty) ) {
                noty.close();
            }
        });

        this.visible.forEach((noty) => {
            if ( filter(noty) ) {
                noty.close();
            }
        });
    }

    onChannelAdd(model) {
        this.add(model);
    }

}